export default {
  baseStyle: {
    w: '100%',
    mx: 'auto',
    maxW: '100%',
    py: '20px',
    px: [6, null, null, 12],
  },
};
